var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.readonly)?_c('div',{class:_vm.classNames},[_vm._v(" "+_vm._s(_vm.formatValue(_vm.value))+" ")]):_c('v-date-picker',{ref:"input",attrs:{"value":_vm.receivedValue,"locale":"pt","input-props":{
    placeholder: 'dd/mm/AAAA',
    class:'appearance-none block w-full bg-grey-lighter text-grey-darker border border-grey-lighter rounded py-3 px-4',
  }},on:{"input":_vm.emitValue}})}
var staticRenderFns = []

export { render, staticRenderFns }